import React from "react";
import { useTranslation } from "react-i18next";

interface CheckoutNavigationProps {
  currentStep: string;
  stepsOrder: string[];
  isSubmitting: boolean;
  canProceed: boolean;
  onPrevious: () => void;
  onNextOrPlaceOrder: () => void;
  formId?: string;
  selectedPaymentMethod: string | null;
}

const CheckoutNavigation: React.FC<CheckoutNavigationProps> = ({
  currentStep,
  stepsOrder,
  isSubmitting,
  canProceed,
  onPrevious,
  onNextOrPlaceOrder,
  formId,
  selectedPaymentMethod,
}) => {
  const { t } = useTranslation();

  const currentStepIndex = stepsOrder.indexOf(currentStep);
  const isLastStep = currentStepIndex === stepsOrder.length - 1;
  const isFirstStep = currentStepIndex === 0;

  // The button triggers form submission for steps with forms, but is a simple button for payment.
  const buttonType = isLastStep ? "button" : "submit";
  const buttonOnClick = isLastStep ? onNextOrPlaceOrder : undefined;

  const getNextButtonText = () => {
    if (isSubmitting) {
      return t("checkout.processing", "Processing...");
    }
    if (isLastStep) {
      switch (selectedPaymentMethod) {
        case "bacs":
          return t("checkout.placeOrderBacs", "Create Order");
        case "paytr_iframe":
          return t("checkout.proceedToPayment", "Proceed to Payment");
        default:
          return t("checkout.placeOrderDefault", "Place Order");
      }
    }
    return t("checkout.next", "Next");
  };

  return (
    <div className="checkout-navigation">
      {/* Previous Button */}
      {!isFirstStep && (
        <button
          type="button"
          onClick={onPrevious}
          className="button button-secondary checkout-nav-button prev-button"
          disabled={isSubmitting}
        >
          {t("checkout.previous", "Previous")}
        </button>
      )}

      {/* Next/Place Order Button --- MODIFIED to use new vars --- */}
      <button
        type={buttonType}
        form={buttonType === "submit" ? formId : undefined}
        onClick={buttonOnClick}
        className={`button button-primary checkout-nav-button ${
          isLastStep ? "place-order-button" : "next-button"
        }`}
        disabled={isSubmitting || !canProceed}
      >
        {getNextButtonText()}
      </button>
    </div>
  );
};

export default CheckoutNavigation;
